import { FC, useContext, } from "react";
import { useTranslation } from "react-i18next";

import { SocketContext, TeamContext } from "../../../context";
import { User } from "../../atoms";


const PlayesListMolecule: FC<{}> = () => {
    const { t } = useTranslation();
    const { players } = useContext(TeamContext);
    const { isProfilePictureUpdated } = useContext(SocketContext);

    const renderPlayers = () => {
        return players.map((player, index: number) => {
            return (
                <User type="list" playerData={player} key={player.email} index={index} isProfilePictureUpdated={isProfilePictureUpdated} />
            )
        });
    };

    return (
        <div className="list_wrapper">

            <div className="linear_gradient_line_horizontal"> </div>

            <div className="list_header">
                <div className="list_header_text"> {t("playersText")}: </div>
                <div className="list_header_text"> {`${players.length}`} </div>
            </div>

            <div className="linear_gradient_line_horizontal"> </div>

            <div className="player_wrapper">
                {renderPlayers()}
            </div>

        </div>
    );
};

export default PlayesListMolecule;